module.exports = __webpack_public_path__ + "img/policy.2bbfc3e1.svg";